// extracted by mini-css-extract-plugin
export default {"switches":"Scope_switches__SCtxS","disabled":"Scope_disabled__wI-bX"};